import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=df2fa16a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df2fa16a')) {
      api.createRecord('df2fa16a', component.options)
    } else {
      api.reload('df2fa16a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=df2fa16a&", function () {
      api.rerender('df2fa16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UEdrliZaySFi/JS/comp/openstreetmap.vue"
export default component.exports